import axios, { AxiosResponse } from "axios";
import config, { setConfig } from "@/config";
// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore
import { APP_ROOT } from "./env.js";

async function loadConfig(url: string): Promise<any> {
  let error: Error;
  let res: AxiosResponse | undefined = undefined;

  if (process.env.VUE_APP_TARGET_ENV === "server" && !url.startsWith("http")) {
    const fs = await import("fs");
    const path = await import("path");
    return JSON.parse(await fs.promises.readFile(path.resolve(__dirname, APP_ROOT + url), "utf-8"));
  }

  try {
    res = await axios.get(url, {
      headers: {
        "Cache-Control": "no-store",
      },
      transformResponse: x => x,
    });
    return JSON.parse(res?.data);
  } catch (e) {
    let errorMsg = `Error loading config from ${url}: ${(e as Error).message}`;
    if (res) errorMsg += `\n status: ${res.status} \n body response: ${res.data.substr(0, 500).replace(/\n/g, "")}`;
    error = new Error(errorMsg);
  }
  return Promise.reject(error!);
}

export default function(devConfig?: Record<string, string>) {
  if (devConfig) {
    setConfig(devConfig);
  }
  return Promise.all([
    loadConfig("/project/js/config.json"),
    loadConfig(`${config.backendUrl}/system-settings/frontend-config`),
  ]).then(configs => {
    configs.forEach(c => setConfig(c));
    if (process.env.NODE_ENV === "development") {
      const features = localStorage.getItem("features");
      if (features) {
        setConfig(JSON.parse(features));
      }
    }
  });
}
